import axios from "@/libs/api.request";
import { sort_ASCII } from "@/libs/utils";

// 获取微信授权信息
export const getAuth = data => axios.request({ 
  url: "/officialAccounts/user", 
  data: {
    ...data,
    sign: sort_ASCII(data)
  }
});

// 绑定游戏账号
export const userRole = data => axios.request({ 
  url: "/officialAccounts/userRole", 
  data: {
    ...data,
    sign: sort_ASCII(data)
  }
});

// 绑定游戏角色
export const roleBind = data => axios.request({ 
  url: "/officialAccounts/roleBind", 
  data: {
    ...data,
    sign: sort_ASCII(data)
  },
  unHint: true
});

// 解绑游戏角色
export const roleUnbind = data => axios.request({ 
  url: "/officialAccounts/roleUnbind", 
  data: {
    ...data,
    sign: sort_ASCII(data)
  }
});

// 更新游戏信息
export const updateRoleBind = data => axios.request({ 
  url: "/officialAccounts/roleUpdate", 
  data: {
    ...data,
    sign: sort_ASCII(data)
  }
});

// 获取游戏角色信息接口
export const getRoleInfo = data => axios.request({
  url: "/officialAccounts/role",
  data: {
    ...data,
    sign: sort_ASCII(data)
  },
  unHint: true
})

// 获取微信sdk授权签名
export const getSign = data => axios.request({
  url: "/officialAccounts/sign",
  data: {
    ...data,
    sign: sort_ASCII(data)
  }
})

// 获取账号服务器接口
export const officialAccountServer = data => axios.request({
  url: "/officialAccounts/server",
  data: {
    ...data,
    sign: sort_ASCII(data)
  }
})